import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyCreditPurchase } from '../services/creditsApi';

function getReturnPath() {
  const saved = localStorage.getItem('stripe_return_path');
  localStorage.removeItem('stripe_return_path');
  return saved || '/map';
}

const CreditSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Verifying purchase...');
  const [error, setError] = useState('');

  useEffect(() => {
    const returnPath = getReturnPath();
    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      setError('Missing session ID');
      setTimeout(() => navigate(returnPath), 2000);
      return;
    }

    let cancelled = false;
    verifyCreditPurchase(sessionId)
      .then((data) => {
        if (cancelled) return;
        setMessage(`100 credits added! Total: ${data.total_credits}`);
        setTimeout(() => navigate(returnPath), 2000);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || 'Verification failed');
        setMessage('Credits may take a moment to appear.');
        setTimeout(() => navigate(returnPath), 3000);
      });

    return () => { cancelled = true; };
  }, [navigate, searchParams]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: '#111', color: '#f5f5f5',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        background: '#1f1f1f', borderRadius: 12, padding: 32,
        textAlign: 'center', maxWidth: 400,
      }}>
        <h2 style={{ margin: '0 0 12px', color: '#00b273' }}>Purchase Successful</h2>
        {error && <p style={{ color: '#ff6b6b', fontSize: 14 }}>{error}</p>}
        <p style={{ color: '#cfcfcf', fontSize: 16 }}>{message}</p>
        <p style={{ color: '#9c9c9c', fontSize: 13 }}>Redirecting back...</p>
      </div>
    </div>
  );
};

export default CreditSuccess;
